import {Component, OnInit} from '@angular/core';
import {CreatePlaylistForm} from '../../../models/';
import {SongsService, MessagesServices} from '../../api/';
import {ToastyService, ToastOptions} from 'ng2-toasty';
import {MdDialogRef} from '@angular/material';

@Component({
    selector: 'app-create-playlist',
    templateUrl: './create-playlist.component.html',
    styleUrls: ['./create-playlist.component.css']
})
export class CreatePlaylistComponent implements OnInit {
    private model: CreatePlaylistForm;
    private messages: any = new Array<any>();
    msg1: any = '';
    title1: any = '';
    msg2: any = '';
    title2: any = '';
    disable: boolean = false;
    public onlineOffline1: boolean = navigator.onLine;

    seasons = [
        'Public',
        'Private',
    ];
    public toolbarOptions = [
        ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
        ['blockquote', 'code-block'],

        [{'header': 1}, {'header': 2}],               // custom button values
        [{'list': 'ordered'}, {'list': 'bullet'}],

        [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
        [{'header': [1, 2, 3, 4, 5, 6, false]}],
    ];
    public editorConfig = {
        placeholder: "Full description",
        modules: {
            toolbar: this.toolbarOptions
        },
        theme: 'snow'
    };


    constructor(public dialogRef: MdDialogRef<CreatePlaylistComponent>, private sm: MessagesServices, private songsService: SongsService,
                private toastyService: ToastyService) {
        window.addEventListener('online', () => {this.onlineOffline1 = true; });
        window.addEventListener('offline', () => {this.onlineOffline1 = false});

        this.model = new CreatePlaylistForm();
        this.disable = false;
        //getting messages from db
        this.messages = this.sm.messags;
        this.setMessages();
    }

    ngOnInit() {

    }

    /**
     * setting system messages
     **/

    setMessages() {
        this.msg1 = '';
        this.title1 = '';
        this.msg2 = '';
        this.title2 = '';
        if (this.messages) {
            for (var i = 0; i < this.messages.length; i++) {
                if (this.messages[i].event == 'WG_EVENT_PLAYLIST_CREATED_SUCCESSFULLY') {
                    this.title1 = this.messages[i].title;
                    this.msg1 = this.messages[i].message;
                }
                if (this.messages[i].event == 'WG_EVENT_PLAYLIST_CANNOT_BE_CREATED') {
                    this.title2 = this.messages[i].title;
                    this.msg2 = this.messages[i].message;
                }
            }
        }
    }

    createPlaylist() {
        this.disable = true;
        //this.setMessages();
        if(this.onlineOffline1){
        this.songsService.createPlaylist(this.model).subscribe((res) => {
            if (res._type === 'playlist') {
                let toastOptions: ToastOptions = {
                    title: this.title1,
                    msg: this.msg1,
                    showClose: true,
                    timeout: 2000,
                    theme: 'default'
                };
                this.toastyService.success(toastOptions);
                this.dialogRef.close(res);
            }
        }, (err) => {
            let toastOptions: ToastOptions = {
                title: this.title2,
                msg: this.msg2,
                showClose: true,
                timeout: 2000,
                theme: 'default'
            };
            this.toastyService.error(toastOptions);
            this.dialogRef.close(false);
        });
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/playlists/create-playlist/create-playlist.component.ts